import {NgModule} from '@angular/core';

import {ApiServicesModule} from './api';

@NgModule({
  declarations: [],
  imports: [ApiServicesModule],
})
export class ServicesModule {}
